/**
 * NOTE: Part of the same older signup flow as ContactInformationForm /
 * PreferencesForm (not currently wired into App routes). Converted for
 * completeness.
 */
import React from 'react';

import CSSModule from 'react-css-modules';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { RouteNames } from '../../../constants';
import messages from './messages';
import styles from './PrivacyPolicyForm.module.scss';

const PRIVACY_POLICY_URL = process.env.REACT_APP_PRIVACY_POLICY_URL || '/legal/privacy-policy';

const PrivacyPolicyForm = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const onAccept = () => {
    navigate(RouteNames.SIGN_UP_REFERRAL_CODE);
  };

  return (
    <div styleName="page">
      <div styleName="card">
        <p styleName="description">Please accept the privacy policy to sign up.</p>

        <div styleName="doc-frame-wrap">
          <iframe
            title="Privacy Policy"
            src={PRIVACY_POLICY_URL}
            styleName="doc-frame"
          />
        </div>

        <button type="button" styleName="accept-btn" onClick={onAccept}>
          {intl.formatMessage(messages.acceptBtn)}
        </button>
      </div>
    </div>
  );
};

export default CSSModule(PrivacyPolicyForm, styles, { allowMultiple: true });
